import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},

    row: {
      marginBottom: spacing(6),
    },
    rowElement: {
      width: `calc(50% - ${spacing(2)}px)`,
      // If there's only one element in the row, padding aligns it with rows that have two
      '&:only-child': {
        paddingRight: spacing(2),
      },
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: '#EAECF0', //TODO change after creating new palette
      margin: spacing(8, 0),
    },

    newBadge: {
      marginRight: spacing(4),
    },
    selectRoot: {
      width: '100%',
    },
    label: {
      display: 'inline-block',
      marginBottom: spacing(2),
      fontWeight: 500,
      lineHeight: '16px',
      color: '#1D2433', //TODO replace after creating new palette
    },
  });
